__webpack_require__.p = "/mailbox-ui/referrals/";